const DocumentIntelligenceProvider = {
        AzureAI: 1,
        AutorecognitionAPI: 2,
        Infomaniak: 3,
        Fixed: 4,
    };
    Object.entries(DocumentIntelligenceProvider).forEach(([key, value]) => {
    DocumentIntelligenceProvider[value] = key;
  });
export default DocumentIntelligenceProvider;